export default {
  index: 'mailing-group-list',
  store: 'mailing-groups-add',
  edit: 'mailing-groups-edit',
};
